import { getItemsFromOrder } from '../utils/item';
import { useWorkflow } from '../workflow/hooks';
import type { OrderItem } from '../graphql/query/getOrder';

export const useItems = (): OrderItem[] => {
  const { order, data } = useWorkflow();

  const items = order ? getItemsFromOrder(data?.items, order) : [];

  return items;
};
